function HeroSection({ onChooseLocation }) {
  return (
    <section className="public-hero" aria-labelledby="home-hero-title">
      <div className="container public-hero-grid">
        <div className="public-hero-copy">
          <p className="eyebrow">Family recipes. Made with love.</p>
          <h1 id="home-hero-title">Good food brings everyone to the table.</h1>
          <p className="public-hero-text">
            Freshly prepared favorites, weekly specials, and catering made for the moments that matter.
          </p>
          <div className="public-hero-actions">
            <button className="btn btn-primary btn-lg" onClick={onChooseLocation} type="button">
              View the Menu
            </button>
            <a className="btn btn-secondary btn-lg" href="/catering">
              Plan Your Catering
            </a>
          </div>
          <ul className="public-trust-list" aria-label="Zayas Kitchen highlights">
            <li>Freshly prepared</li>
            <li>Convenient pickup</li>
            <li>Weekly specials</li>
            <li>Catering available</li>
          </ul>
        </div>

        <div className="public-hero-image" aria-label="Homestyle dishes served family style" role="img">
          <div className="public-hero-card">
            <span className="badge badge-weekly">This Week</span>
            <strong>Comfort food, ready when your family is.</strong>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;